(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-program"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-b2b]').forEach(function (root) {
  var prices = {
    standard: { annual: parseInt(root.dataset.stdAnnual, 10) / 100, monthly: parseInt(root.dataset.stdMonthly, 10) / 100, single: parseInt(root.dataset.stdSingle, 10) / 100 },
    glove: { annual: parseInt(root.dataset.gloveAnnual, 10) / 100, monthly: parseInt(root.dataset.gloveMonthly, 10) / 100, single: parseInt(root.dataset.gloveSingle, 10) / 100 }
  };
  var discount = (parseFloat(root.dataset.multiDiscount) || 0) / 100;
  var zips = (root.dataset.zips || '').split(/[\s,]+/).filter(Boolean);
  var billing = 'annual';

  var tabs = root.querySelectorAll('.b2b-tab');
  var panels = root.querySelectorAll('.b2b-space');
  var spaceSelect = root.querySelector('#b2b-space');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.space; });
      if (spaceSelect && !spaceSelect.value) { spaceSelect.value = t.textContent.trim(); }
    });
  });

  var billSelect = root.querySelector('#b2b-bill');
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function applyBilling() {
    root.querySelectorAll('[data-annual]').forEach(function (el) { el.textContent = el.dataset[billing]; });
    root.querySelectorAll('.b2b-billing button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bill === billing ? 'true' : 'false'); });
    if (billSelect && billSelect.value !== billing) { billSelect.value = billing; }
    root.querySelectorAll('[data-single-note]').forEach(function (el) { el.hidden = billing !== 'single'; });
    estimate();
  }
  root.querySelectorAll('.b2b-billing button').forEach(function (b) {
    b.addEventListener('click', function () { billing = b.dataset.bill; applyBilling(); });
  });
  if (billSelect) { billSelect.addEventListener('change', function (e) { billing = e.target.value; applyBilling(); }); }

  var form = root.querySelector('[data-b2b-form]');
  var pickGlove = root.querySelector('[data-pick-glove]');
  var radioGlove = pickGlove ? pickGlove.querySelector('input') : null;
  var radioStd = root.querySelector('[data-pick-std] input');
  root.querySelectorAll('[data-choose]').forEach(function (a) {
    a.addEventListener('click', function () {
      var r = a.dataset.choose === 'glove' ? radioGlove : radioStd;
      if (r && !r.disabled) { r.checked = true; estimate(); }
    });
  });

  function inRange(z) {
    return zips.some(function (rule) {
      if (rule.indexOf('*') > -1) { return z.indexOf(rule.replace(/\*/g, '')) === 0; }
      return rule === z;
    });
  }
  var zip = root.querySelector('#b2b-zip');
  var msg = root.querySelector('[data-glove-msg]');
  if (zip && msg && pickGlove) {
    zip.addEventListener('input', function () {
      var z = zip.value.replace(/\D/g, '');
      zip.value = z;
      if (z.length < 5) { msg.hidden = true; pickGlove.classList.remove('b2b-pick--off'); radioGlove.disabled = false; return; }
      if (inRange(z)) {
        msg.hidden = false; msg.className = 'b2b-glove-msg b2b-glove-msg--ok'; msg.textContent = msg.dataset.ok.replace('{zip}', z);
        pickGlove.classList.remove('b2b-pick--off'); radioGlove.disabled = false;
      } else {
        msg.hidden = false; msg.className = 'b2b-glove-msg'; msg.textContent = msg.dataset.no.replace('{zip}', z);
        pickGlove.classList.add('b2b-pick--off'); radioGlove.disabled = true; radioStd.checked = true;
      }
      estimate();
    });
  }

  var locs = root.querySelector('#b2b-locs');
  var estVal = root.querySelector('[data-est-val]');
  var estDisc = root.querySelector('[data-est-disc]');
  var estHidden = root.querySelector('[data-est-hidden]');
  function estimate() {
    if (!estVal) { return; }
    var checked = root.querySelector('input[name="contact[Plan]"]:checked');
    var plan = checked && checked.value === 'Green Glove' ? 'glove' : 'standard';
    var n = Math.max(1, Math.min(50, parseInt(locs && locs.value ? locs.value : '1', 10) || 1));
    var base = prices[plan][billing];
    var per = billing === 'annual' ? 'year' : (billing === 'single' ? 'season' : 'month');
    if (n >= 5) {
      estVal.textContent = 'Custom quote';
      estDisc.textContent = n + ' locations';
      if (estHidden) { estHidden.value = 'Custom quote (' + n + ' locations, ' + billing + ')'; }
      return;
    }
    var total = base + (n - 1) * base * (1 - discount);
    estVal.innerHTML = money(total) + ' <small>/ ' + per + '</small>';
    estDisc.textContent = n > 1 ? n + ' locations, ' + money((n - 1) * base * discount) + ' saved' : '';
    if (estHidden) { estHidden.value = money(total) + ' / ' + per + ' (' + n + ' location' + (n > 1 ? 's' : '') + ')'; }
  }
  if (locs) { locs.addEventListener('input', estimate); }
  root.querySelectorAll('input[name="contact[Plan]"]').forEach(function (r) { r.addEventListener('change', estimate); });

  var source = root.querySelector('[data-source]');
  if (source) {
    try {
      var p = new URLSearchParams(location.search);
      source.value = p.get('utm_source') || (document.referrer ? 'referral: ' + new URL(document.referrer).hostname : 'direct (flyer or typed)');
    } catch (e) { source.value = 'direct'; }
  }

  if (form) {
    form.addEventListener('submit', function () {
      var email = root.querySelector('#b2b-email');
      var name = root.querySelector('#b2b-name');
      var checked = root.querySelector('input[name="contact[Plan]"]:checked');
      if (!email || !email.value) { return; }
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email.value);
      if (name && name.value) { fd.append('contact[first_name]', name.value.split(' ')[0]); }
      fd.append('contact[tags]', 'b2b-lead, b2b-' + (checked && checked.value === 'Green Glove' ? 'green-glove' : 'standard'));
      try { fetch('/contact', { method: 'POST', body: fd, keepalive: true, credentials: 'same-origin' }); } catch (e) {}
    });
  }

  var thanks = root.querySelector('[data-b2b-thanks]');
  if (thanks) {
    thanks.scrollIntoView({ block: 'center' });
    thanks.focus({ preventScroll: true });
    if (window.dataLayer) { window.dataLayer.push({ event: 'b2b_lead_submitted' }); }
  }

  var navLinks = root.querySelectorAll('[data-subnav]');
  if (navLinks.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { navLinks.forEach(function (l) { l.classList.toggle('is-on', l.dataset.subnav === e.target.id); }); }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    navLinks.forEach(function (l) { var el = document.getElementById(l.dataset.subnav); if (el) { io.observe(el); } });
  }

  applyBilling();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["residents-program"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-evr-res]').forEach(function (root) {
  var code = root.dataset.code;
  try {
    var p = new URLSearchParams(location.search).get('code');
    if (p && /^[A-Za-z0-9_-]{3,30}$/.test(p)) {
      var old = root.dataset.code; code = p.toUpperCase();
      root.querySelectorAll('[data-disc]').forEach(function (a) { a.setAttribute('href', a.getAttribute('href').replace('/discount/' + old, '/discount/' + encodeURIComponent(code))); });
    }
  } catch (e) {}
  root.querySelectorAll('[data-code-text]').forEach(function (el) { el.textContent = code; });
  var btn = root.querySelector('[data-copy-code]');
  var label = root.querySelector('[data-copy-label]');
  if (btn) {
    btn.addEventListener('click', function () {
      var done = function () { if (label) { label.textContent = 'Copied. It also applies automatically below.'; } };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["str-program"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-str]').forEach(function (root) {
  var d = root.dataset;
  var prices = {
    standard: { annual: parseInt(d.stdAnnual, 10) / 100, monthly: parseInt(d.stdMonthly, 10) / 100, single: parseInt(d.stdSingle, 10) / 100 },
    glove: { annual: parseInt(d.gloveAnnual, 10) / 100, monthly: parseInt(d.gloveMonthly, 10) / 100, single: parseInt(d.gloveSingle, 10) / 100 }
  };
  var tiers = {
    t2min: parseInt(d.tier2Min, 10) || 2, t2: (parseFloat(d.tier2Pct) || 0) / 100,
    t3min: parseInt(d.tier3Min, 10) || 4, t3: (parseFloat(d.tier3Pct) || 0) / 100,
    custom: parseInt(d.customMin, 10) || 7
  };
  var holidays = parseInt(d.holidays, 10) || 6;
  var zips = (d.zips || '').split(/[\s,]+/).filter(Boolean);
  var state = { n: 1, plan: 'standard', billing: 'annual', gloveOk: true, offer: false };

  function money(x) { return '$' + Math.round(x).toLocaleString('en-US'); }
  function rate(n) { if (n >= tiers.t3min) { return tiers.t3; } if (n >= tiers.t2min) { return tiers.t2; } return 0; }
  function quote() {
    var base = prices[state.plan][state.billing];
    if (state.n >= tiers.custom) { return null; }
    var r = rate(state.n), list = base * state.n, total = list * (1 - r);
    return { total: total, list: list, saved: list - total, each: total / state.n, rate: r };
  }
  function perWord() { return state.billing === 'annual' ? 'year' : (state.billing === 'single' ? 'season' : 'month'); }
  function propWord(n) { return n === 1 ? 'property' : 'properties'; }

  /* Property tabs */
  var tabs = root.querySelectorAll('.str-tab');
  var panels = root.querySelectorAll('.str-space');
  var typeSelect = root.querySelector('#str-type');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.space; });
      if (typeSelect && !typeSelect.value) { typeSelect.value = t.textContent.trim(); }
    });
  });

  /* Offer (free first box) for email arrivals */
  var offerEls = root.querySelectorAll('[data-offer],[data-offer-form],[data-offer-line]');
  var offerField = root.querySelector('[data-offer-field]');
  (function () {
    if (d.offerOn !== 'true') { return; }
    var sources = (d.offerSources || '').toLowerCase().split(/[\s,]+/).filter(Boolean);
    var p; try { p = new URLSearchParams(location.search); } catch (e) { return; }
    var src = (p.get('utm_source') || '').toLowerCase();
    var hit = p.get('offer') === 'firstbox' || (src && sources.indexOf(src) > -1);
    try { if (hit) { sessionStorage.setItem('str-offer', '1'); } else if (sessionStorage.getItem('str-offer')) { hit = true; } } catch (e) {}
    if (!hit) { return; }
    state.offer = true;
    offerEls.forEach(function (el) { el.hidden = false; });
    if (offerField) { offerField.value = d.offerLabel || 'First box free'; }
  })();

  /* Shared controls: billing, plan, count */
  var billSelect = root.querySelector('#str-bill');
  var calcN = root.querySelector('[data-calc-n]');
  var formN = root.querySelector('[data-form-n]');
  var radioStd = root.querySelector('[data-pick-std] input');
  var pickGlove = root.querySelector('[data-pick-glove]');
  var radioGlove = pickGlove ? pickGlove.querySelector('input') : null;

  function setPlan(plan) {
    if (plan === 'glove' && !state.gloveOk) { plan = 'standard'; }
    state.plan = plan;
    if (plan === 'glove' && radioGlove) { radioGlove.checked = true; } else if (radioStd) { radioStd.checked = true; }
    render();
  }
  function setN(n) {
    n = Math.max(1, Math.min(50, parseInt(n, 10) || 1));
    state.n = n;
    if (calcN && calcN.value !== String(n)) { calcN.value = n; }
    if (formN && formN.value !== String(n)) { formN.value = n; }
    render();
  }
  function setBilling(b) { state.billing = b; render(); }

  root.querySelectorAll('.str-billing button').forEach(function (b) { b.addEventListener('click', function () { setBilling(b.dataset.bill); }); });
  if (billSelect) { billSelect.addEventListener('change', function (e) { setBilling(e.target.value); }); }
  root.querySelectorAll('[data-calc-plan]').forEach(function (b) { b.addEventListener('click', function () { setPlan(b.dataset.calcPlan); }); });
  root.querySelectorAll('[data-choose]').forEach(function (a) { a.addEventListener('click', function () { setPlan(a.dataset.choose); }); });
  root.querySelectorAll('input[name="contact[Plan]"]').forEach(function (r) { r.addEventListener('change', function () { setPlan(r.value === 'Green Glove' ? 'glove' : 'standard'); }); });
  root.querySelectorAll('[data-step]').forEach(function (b) { b.addEventListener('click', function () { setN(state.n + parseInt(b.dataset.step, 10)); }); });
  if (calcN) { calcN.addEventListener('input', function () { if (calcN.value !== '') { setN(calcN.value); } }); calcN.addEventListener('blur', function () { setN(calcN.value); }); }
  if (formN) { formN.addEventListener('input', function () { if (formN.value !== '') { setN(formN.value); } }); }

  /* ZIP gating for Green Glove */
  function inRange(z) {
    return zips.some(function (rule) {
      if (rule.indexOf('*') > -1) { return z.indexOf(rule.replace(/\*/g, '')) === 0; }
      return rule === z;
    });
  }
  var zip = root.querySelector('#str-zip');
  var msg = root.querySelector('[data-glove-msg]');
  if (zip && msg && pickGlove) {
    zip.addEventListener('input', function () {
      var z = zip.value.replace(/\D/g, '');
      zip.value = z;
      if (z.length < 5) { msg.hidden = true; pickGlove.classList.remove('str-pick--off'); radioGlove.disabled = false; state.gloveOk = true; render(); return; }
      if (inRange(z)) {
        msg.hidden = false; msg.className = 'str-glove-msg str-glove-msg--ok'; msg.textContent = msg.dataset.ok.replace('{zip}', z);
        pickGlove.classList.remove('str-pick--off'); radioGlove.disabled = false; state.gloveOk = true; render();
      } else {
        msg.hidden = false; msg.className = 'str-glove-msg'; msg.textContent = msg.dataset.no.replace('{zip}', z);
        pickGlove.classList.add('str-pick--off'); radioGlove.disabled = true; state.gloveOk = false; setPlan('standard');
      }
    });
  }

  /* Render everything from state */
  var calcTotal = root.querySelector('[data-calc-total]');
  var calcPer = root.querySelector('[data-calc-per]');
  var calcMeta = root.querySelector('[data-calc-meta]');
  var calcHoliday = root.querySelector('[data-calc-holiday]');
  var calcBe = root.querySelector('[data-calc-be]');
  var calcAddon = root.querySelector('[data-calc-addon]');
  var calcCta = root.querySelector('[data-calc-cta]');
  var estVal = root.querySelector('[data-est-val]');
  var estDisc = root.querySelector('[data-est-disc]');
  var estHidden = root.querySelector('[data-est-hidden]');
  var welcomeBox = root.querySelector('[data-welcome]');
  var welcomePrice = parseFloat(d.welcomePrice) || 0;
  if (welcomeBox) { welcomeBox.addEventListener('change', function () { render(); }); }
  var ctaBase = calcCta ? calcCta.textContent : '';

  function render() {
    root.querySelectorAll('[data-annual]').forEach(function (el) { el.textContent = el.dataset[state.billing]; });
    root.querySelectorAll('.str-billing button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bill === state.billing ? 'true' : 'false'); });
    root.querySelectorAll('[data-calc-plan]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.calcPlan === state.plan ? 'true' : 'false');
      b.disabled = b.dataset.calcPlan === 'glove' && !state.gloveOk;
    });
    if (billSelect && billSelect.value !== state.billing) { billSelect.value = state.billing; }
    root.querySelectorAll('[data-single-note]').forEach(function (el) { el.hidden = state.billing !== 'single'; });

    var q = quote(), per = perWord(), n = state.n;
    var annualEach = q ? (state.billing === 'annual' ? q.each : (state.billing === 'single' ? q.each * holidays : q.each * 12)) : 0;
    var perHoliday = annualEach / holidays;
    var summary;

    if (!q) {
      summary = 'Custom quote (' + n + ' properties, ' + state.plan + ', ' + state.billing + ')';
      if (calcTotal) { calcTotal.textContent = 'Custom quote'; calcPer.textContent = ''; }
      if (calcMeta) { calcMeta.textContent = n + ' properties. We\'ll build pricing around your portfolio and send it within one business day.'; }
      if (calcHoliday) { calcHoliday.textContent = ''; }
      if (calcBe) { calcBe.hidden = true; }
      if (estVal) { estVal.textContent = 'Custom quote'; estDisc.textContent = n + ' properties'; }
    } else {
      summary = money(q.total) + ' / ' + per + ' (' + n + ' ' + propWord(n) + (q.rate ? ', ' + Math.round(q.rate * 100) + '% off' : '') + ')';
      if (calcTotal) { calcTotal.textContent = money(q.total); calcPer.textContent = '/ ' + per; }
      if (calcMeta) {
        calcMeta.textContent = n === 1
          ? 'One property, one box before every holiday.'
          : money(q.each) + ' per property. ' + Math.round(q.rate * 100) + '% off every box, ' + money(q.saved) + ' saved per ' + per + '.';
      }
      if (calcHoliday) { calcHoliday.textContent = 'About ' + money(perHoliday) + ' per property, per holiday.'; }
      if (estVal) {
        estVal.innerHTML = money(q.total) + ' <small>/ ' + per + '</small>';
        estDisc.textContent = n > 1 ? n + ' properties, ' + Math.round(q.rate * 100) + '% off, ' + money(q.saved) + ' saved' : '';
      }
      if (calcBe && calcAddon) {
        var a = parseFloat(calcAddon.value);
        if (a > 0) {
          var stays = Math.ceil(perHoliday / a);
          calcBe.hidden = false;
          calcBe.innerHTML = 'At ' + money(a) + ' per stay, each box pays for itself after <strong>' + stays + ' booking' + (stays === 1 ? '' : 's') + ' per holiday</strong>. Every stay after that is margin.';
        } else { calcBe.hidden = true; }
      }
    }
    if (calcCta) { calcCta.textContent = n === 1 ? ctaBase : ctaBase.replace(/\bboxes\b/i, n + ' boxes'); }
    if (welcomeBox && welcomeBox.checked && welcomePrice > 0) {
      var seasonsPer = state.billing === 'annual' ? holidays : (state.billing === 'single' ? 1 : holidays / 12);
      var wTotal = welcomePrice * n * seasonsPer;
      var wLine = '+ welcome box ' + money(wTotal) + ' / ' + per;
      if (estDisc) { estDisc.textContent = (estDisc.textContent ? estDisc.textContent + ' · ' : '') + wLine; }
      summary += ', ' + wLine;
    }
    if (estHidden) { estHidden.value = summary + (state.offer ? ', first box free' : ''); }
  }
  if (calcAddon) { calcAddon.addEventListener('input', render); }

  /* Source capture + background customer create for Flow */
  var source = root.querySelector('[data-source]');
  if (source) {
    try {
      var sp = new URLSearchParams(location.search);
      source.value = sp.get('utm_source') || (document.referrer ? 'referral: ' + new URL(document.referrer).hostname : 'direct (typed or saved)');
    } catch (e) { source.value = 'direct'; }
  }
  var form = root.querySelector('[data-str-form]');
  if (form) {
    form.addEventListener('submit', function () {
      var email = root.querySelector('#str-email');
      var name = root.querySelector('#str-name');
      if (!email || !email.value) { return; }
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email.value);
      if (name && name.value) { fd.append('contact[first_name]', name.value.split(' ')[0]); }
      fd.append('contact[tags]', 'str-lead, str-' + (state.plan === 'glove' ? 'green-glove' : 'standard') + (state.offer ? ', str-firstbox' : '') + (welcomeBox && welcomeBox.checked ? ', str-welcome-box' : ''));
      try { fetch('/contact', { method: 'POST', body: fd, keepalive: true, credentials: 'same-origin' }); } catch (e) {}
    });
  }

  var thanks = root.querySelector('[data-str-thanks]');
  if (thanks) {
    thanks.scrollIntoView({ block: 'center' });
    thanks.focus({ preventScroll: true });
    if (window.dataLayer) { window.dataLayer.push({ event: 'str_lead_submitted' }); }
  }

  var navLinks = root.querySelectorAll('[data-subnav]');
  if (navLinks.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { navLinks.forEach(function (l) { l.classList.toggle('is-on', l.dataset.subnav === e.target.id); }); }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    navLinks.forEach(function (l) { var el = document.getElementById(l.dataset.subnav); if (el) { io.observe(el); } });
  }

  render();
});

  } catch(e) { console.error(e); }
})();
})();
